import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { sharedLoginCheck } from '../../authentication/sharedLoginCheck';
import { intlShape, injectIntl } from 'react-intl';
import Button from '../../global/Button/Button';

import styles from './LoginCheck.scss';

class LoginCheck extends Component {
    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        const { onSuccess } = this.props;
        sharedLoginCheck({ onSuccess });
    }

    render() {
        const { buttonProps, link, linkProps, className, message, intl } = this.props;
        return link ? (
            <span className={classnames(styles.link, className)} onClick={this.onClick}>
                {linkProps && linkProps.children}
            </span>
        ) : (
            <Button
                className={className}
                onClick={this.onClick}
                text={message && intl.formatMessage(message)}
                {...buttonProps}
            />
        );
    }
}

LoginCheck.defaultProps = {
    onSuccess() {},
    buttonProps: { fullWidth: true },
};

LoginCheck.propTypes = {
    onSuccess: PropTypes.func.isRequired,
    message: PropTypes.shape({
        id: PropTypes.string,
        defaultMessage: PropTypes.string,
    }),
    buttonProps: PropTypes.object,
    link: PropTypes.bool,
    linkProps: PropTypes.shape({
        children: PropTypes.node,
    }),
    className: PropTypes.string,
    intl: intlShape.isRequired,
};

LoginCheck = injectIntl(LoginCheck);

export default LoginCheck;
